// extracted by mini-css-extract-plugin
export default {"successModal":"ForcedLogoutModal_successModal__mrPPu","inner":"ForcedLogoutModal_inner__n00hG","text":"ForcedLogoutModal_text__mwQo1"};